import { render, staticRenderFns } from "./LoginModal.vue?vue&type=template&id=4a52a220&scoped=true"
import script from "./LoginModal.js?vue&type=script&lang=js&external"
export * from "./LoginModal.js?vue&type=script&lang=js&external"
import style0 from "./LoginModal.scss?vue&type=style&index=0&id=4a52a220&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a52a220",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SecondaryLoadingSpinner: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/SecondaryLoadingSpinner.vue').default})
